var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.currentState
    ? _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "940px" },
          model: {
            value: _setup.showDialog,
            callback: function ($$v) {
              _setup.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "modal-add-folder lf-modal-drop" },
            [
              _c(
                "v-card-title",
                [
                  _c(_setup.CustomDialogHeaderComponent, {
                    attrs: { "header-title": _setup.texts.title },
                  }),
                ],
                1
              ),
              _c(
                "v-card-text",
                { attrs: { classstyle: "height: 650px" } },
                _vm._l(_setup.fileList, function (file, index) {
                  return _c(
                    "span",
                    { key: file.name + index },
                    [
                      _c(_setup.FileLoadingComponent, {
                        attrs: { file: file },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
              _c("v-card-actions", { staticClass: "modal-footer" }, [
                _c(
                  "div",
                  { staticClass: "right" },
                  [
                    !_setup.isLoading
                      ? _c(_setup.LfLabelButtonComponent, {
                          staticClass: "button",
                          attrs: {
                            text: _setup.texts.buttons.finish,
                            action: _setup.onFinnished,
                            variant: _setup.LabelButtonVariant.SOLID,
                          },
                        })
                      : _c(_setup.LfLabelButtonComponent, {
                          staticClass: "button",
                          attrs: {
                            text: _setup.texts.buttons.cancel,
                            action: _setup.onCancel,
                            variant: _setup.LabelButtonVariant.OUTLINED,
                          },
                        }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }